/* eslint-disable react-native/no-color-literals */
import { GENERAL_STYLES } from '#constants/styles';

export default GENERAL_STYLES;
